<script>
import Post from './Post'

export default {
  name: 'Posts',
  components: {
    Post,
  },
  computed: {
    posts() { return this.$store.getters['post/posts'] }, // Посты
  },
}
</script>

<template>
  <section>
    <Post
      v-for="post in posts"
      :key="post.id"
      :post-id="post.id"
      class="mb-6"
    />
    <VAlert
      v-if="posts && !posts.length"
      border="left"
      outlined
      color="primary"
      icon="mdi-post"
    >
      Вы увидите здесь ежедневные отчеты по сотрудникам,
      новые отчеты появляются каждую ночь.
    </VAlert>
  </section>
</template>
